import { apiFetch } from './client';

export const getTenableStatus  = ()            => apiFetch('/tenable/status');
export const testTenableConn   = ()            => apiFetch('/tenable/test', { method: 'POST' });
export const syncAssets        = ()            => apiFetch('/tenable/sync/assets', { method: 'POST' });
export const syncVulns         = ()            => apiFetch('/tenable/sync/vulns',  { method: 'POST' });
export const getVulnSummary    = ()            => apiFetch('/tenable/vulns/summary');
export const getVulns          = (params = {}) => apiFetch('/tenable/vulns?' + new URLSearchParams(params));
export const getAssetVulns     = (assetId)     => apiFetch(`/tenable/asset/${assetId}/vulns`);
export const markVulnPatched   = (vulnId)      => apiFetch(`/tenable/vuln/${vulnId}/patch`, { method: 'PATCH' });
